module.exports = {
    headers:{
        navbar:['Home page','Main products','Company introduction','Contact us'],
        products:['Product one','Product two','Product three','Product four']
    },
    bodys:{
        infotitle:['address','contact','traffic'],
        information:{
            address:'Optical Valley Science and technology port, No. 18, huashiyuan North Road, Donghu New Technology Development Zone, Wuhan',
            phone:'027-63494808',
            bus:'bus：789 to wudayuan Road 1',
            subway:'metro：Line 2 - Xiuhu'
        }
    },
    footers:{
        baceInfo:{
            companyName:'Wuhan Yunxi Information Technology Co., Ltd',
            address:'Optical Valley Science and technology port, No. 18, huashiyuan North Road, Donghu New Technology Development Zone, Wuhan',
            phone:'phone:1234567890',
            fax:'fax:1234567890',
            copyright:'copyright © Wuhan Yunxi Information Technology Co., Ltd',
            record:'Filing No.: Yue ICP Bei xxxxxxxxx No'
        }
    }
    
}